<template>
  <div :key="keyComp" class="info_window">
    <div v-if="placements" class="info_window_wrapper">
      <div class="thumbnail_section">
        <div v-for="(data, index) in placements.placement" :key="index" >
          <a :href="loadBillboardImgUrl(data.image)" target="_blank">
            <img class="bg_img photo" :src="loadBillboardImg(data.thumbnail)" alt >
          </a>
        </div>
        <a><img class="icon_time" src="img/icons/adx-ic-time.png" onclick="toggleModal()"></a>
        <a v-if="showSlider()" class="prev icon-chevronleft" onclick="prev()"></a>
        <a v-if="showSlider()" class="next icon-chevronright" onclick='next()'></a>
        <template v-if="showSlider()">
          <div v-for="(data, index) in placements.placement" :key="'A' + index">
            <div class="index_number">
              <div class="numberText">{{Math.abs(index - placements.placement.length)}} / {{placements.placement.length}}</div>
            </div>
          </div>
        </template>
      </div>
        <div class="info_section">
          <div v-for="(data, index) in placements.placement" :key="'B' + index">
             <div class="edit_detail">
              <button class="button" onclick="reuseContent()">Reuse Content</button>
              <button class="button2" onclick="toggleModalEdit()">Edit</button>
              <div class="separator"></div>
              <div class="row_data side">
                <span class="left">Updated </span>
                <span class="right">{{showDate(data.last_updated)}}</span>
              </div>
              <div class="row_data side">
                <span class="left">By </span>
                <span class="right">{{data.updated_by}}</span>
              </div>
              <div class="separator"></div>
            </div>
         </div>
          <div class="row_data">
            <span>Advertising </span>
          </div>
          <div v-for="(data, index) in placements.placement" :key="'D' + index" >
            <div class="advertising">
              <div class="row_data">
                <span class="left">Brand </span>
                <span v-if="data.brand" class="right">{{data.brand.name ? data.brand.name : '-'}}</span>
              </div>
              <div class="row_data">
                <span class="left">Message </span>
              </div>
              <div class="row_data">
              <span class="bottom">{{data.message ? data.message : '-'}}</span>
              </div>
            </div>
            <div class="empty">
            <div class="row_data">
              <div class="info">*This Placement doesn’t have any placement Right now</div>
            </div>
            </div>
            <div class="ownerInfo">
            <div class="separator"></div>
            <div class="row_data side">
              <span class="left">Owner </span>
              <span class="right">{{placements.vendor ? placements.vendor : '-'}}</span>
            </div>
            <div class="row_data side">
              <span class="left">Contact </span>
              <span class="right">{{placements.phone ? placements.phone : '-'}}</span>
            </div>
            </div>
          </div>
          <div class="separator"></div>
          <div v-for="(data, index) in placements.placement" :key="'C' + index" >
            <div class="section">
            <div class="row_data side">
              <span class="left">Code </span>
              <span class="right">{{placements.code ? placements.code : '-'}}</span>
            </div>
            <div class="row_data">
              <span class="left">Media Type </span>
              <span class="right">{{placements.media_type ? placements.media_type : '-'}}</span>
            </div>
            <div class="row_data">
              <span class="left">Road Side </span>
              <span class="right">{{placements.road_side ? placements.road_side : '-'}}</span>
            </div>
            <div class="row_data">
                <span class="left">Road To </span>
            </div>
              <div class="row_data road">
              <span class="bottom">{{data.road_to ? data.road_to : '-'}}</span>
              </div>
            </div>
          </div>
          <div class="price_note"></div>
        </div>
    </div>
  </div>
</template>

<script>
import { AModal } from "ui-kit-v1"
import lib from '@/lib/util'
import moment from 'moment'
export default {
  name: 'info-window',
  components : {
    "adx-modal": AModal
  },
  props: {
    placements: { type : Object },
    isStaff: {type : Boolean},
    isSuperuser: {type : Boolean},
    keyComp: { type : Number }
  },
  data(){
    return{
      slideIndex : [],
      id_placement: null,
      side : null
    }
  },
  beforeMount() {},
  beforeUpdate() {},
  mounted(){
  },
  updated() {
    this.$emit('updateData')
    this.side = this.placements.placement[this.placements.placement.length - 1].side
    this.slideIndex = [this.placements.placement.length - 1, this.placements.placement.length - 1, this.placements.placement.length - 1, 
    this.placements.placement.length - 1, this.placements.placement.length - 1, this.placements.placement.length - 1, this.placements.placement.length - 1]
    this.id_placement = this.placements.placement[this.placements.placement.length - 1].id
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    next() {
      this.showSlides(this.slideIndex[0] - 1, "section", "block", 0);
      this.showSlides(this.slideIndex[1] - 1, "ownerInfo", "block", 1);
      this.showSlides(this.slideIndex[2] - 1, "photo", "flex", 2);
      this.showSlides(this.slideIndex[3] - 1, "advertising", "block", 3);
      this.showSlides(this.slideIndex[4] - 1, "empty", "block", 4);
      this.showSlides(this.slideIndex[5] - 1, "index_number", "block", 5);
      this.showSlides(this.slideIndex[6] - 1, "edit_detail", "block", 6);
    },
    prev() {
      this.showSlides(this.slideIndex[0] + 1, "section", "block", 0);
      this.showSlides(this.slideIndex[1] + 1, "ownerInfo", "block", 1);
      this.showSlides(this.slideIndex[2] + 1, "photo", "flex", 2);
      this.showSlides(this.slideIndex[3] + 1, "advertising", "block", 3);
      this.showSlides(this.slideIndex[4] + 1, "empty", "block", 4);
      this.showSlides(this.slideIndex[5] + 1, "index_number", "block", 5);
      this.showSlides(this.slideIndex[6] + 1, "edit_detail", "block", 6);
    },
    showSlides(n, div, style, num){
      var i;
      var empty = this.placements.placement.map( data => data.is_empty)
      var slides = document.getElementsByClassName(div);
      if (n > (slides.length/2 - 1)) {n = 0}    
      if (n < 0) {n = (slides.length/2 - 1)}
      for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";  
      }
      slides[n].style.display = style;
      if(empty[n] == true){
        var slidesAdvert = document.getElementsByClassName("advertising");
        for (i = 0; i < slidesAdvert.length; i++) {
            slidesAdvert[i].style.display = "none";  
        }
      }else if(empty[n] == false){
        var slidesEmpty = document.getElementsByClassName("empty");
        var slidesOwner = document.getElementsByClassName("ownerInfo");
        for (i = 0; i < slidesEmpty.length; i++) {
            slidesEmpty[i].style.display = "none";  
            slidesOwner[i].style.display = "none";
        }
      }
      if(!this.isStaff && !this.isSuperuser){
        var slidesOwner = document.getElementsByClassName("ownerInfo");
        var editDetail = document.getElementsByClassName("edit_detail");
        for (i = 0; i < slidesOwner.length; i++) {
            slidesOwner[i].style.display = "none";
            editDetail[i].style.display = "none";  
        }
      }
      this.slideIndex[num] = n
      this.id_placement = this.placements.placement[n].id
      this.side = this.placements.placement[n].side
    },
    loadBillboardImg(photo) {
      if (photo) {
        return photo
      }else{
        return '/img/notfound/img-placeholder-landscape@2x.png'
      }
    },
    loadBillboardImgUrl(photo) {
      if (photo) {
        return photo
      }
      return '#'
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    showSlider() {
      return this.placements.placement.length > 1
    },
    toggleModalEdit(){
      this.$emit('toggleModalEdit', this.id_placement)
    },
    reuseContent(){
      this.$emit('reuseContent', this.id_placement)
    },
    showDate(date){
      if(date){
        var dategmt = moment(date);
        return `${lib.formatShortDate(dategmt)}`
      }
    },
    toggleModal(){
        this.$emit('toggleModal', this.side)
    }
  },
  created() {
    const vm = this
    window.next = function() {
      vm.next()
    }
    window.prev = function() {
      vm.prev()
    }
    window.toggleModalEdit = function(){
      vm.toggleModalEdit()
    }
    window.reuseContent = function(){
      vm.reuseContent()
    }
    window.toggleModal = function() {
      vm.toggleModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.index_number {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(38, 38, 38, 0.8);
  text-align: center;
  padding: 4px 8px;
  border-radius: 12px;
}
.info_content {
  display: flex;
  flex-direction: column;
}

.info_window {
  display: flex;
  flex-direction: column;
  width: 257px;

  .info_window_wrapper {
    height: 100%;
    width: 100%;

    .thumbnail_section {
      position: relative;
      height: 240px;
      margin-bottom: 16px;
      
      a{
        cursor: default;
      }

      .bg_img {
        margin-top: -4px;
        width: 257px;
        height: 240px;
        object-fit: cover;
        cursor: pointer;
        animation: fadein 2s;
        -moz-animation: fadein 2s; /* Firefox */
        -webkit-animation: fadein 2s; /* Safari and Chrome */
        -o-animation: fadein 2s; /* Opera */
      }
      @keyframes fadein {
          from {
              opacity:0;
          }
          to {
              opacity:1;
          }
      }
      @-moz-keyframes fadein { /* Firefox */
          from {
              opacity:0;
          }
          to {
              opacity:1;
          }
      }
      @-webkit-keyframes fadein { /* Safari and Chrome */
          from {
              opacity:0;
          }
          to {
              opacity:1;
          }
      }
      @-o-keyframes fadein { /* Opera */
          from {
              opacity:0;
          }
          to {
              opacity: 1;
          }
      }
      .prev, .next {
        cursor: pointer;
        position: absolute;
        top: 55%;
        width: auto;
        padding: 4px;
        margin-top: -22px;
        margin-left: 8px;
        color: black;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        transition: 0.6s ease;
        user-select: none;
        border-radius: 25px;
        background-color: #fff;
      }
      .next {
        left: 216px;
      }
      .numberText{
        font-family: CoreSansC-65;
        font-size: 11px;
        font-weight: bold;
        color: white;
      }

      .icon_time{
        cursor: pointer;
        position: absolute;
        top: 10px;
        left: 185px;
        width: auto;
        padding: 4px;
        margin-left: 8px;
        transition: 0.6s ease;
        border-radius: 25px;
        background-color: #fff;
      }
    }

    .info_section {
      padding: 0 16px 16px 16px;
      max-height: 230px;
      overflow-y: auto;

      .button, .button2{
        background-color: #ffffff;
        padding: 6px 8px;
        font-size: 13px;
        border: solid 1px #999999;
        border-radius: 4px;
      }

      .button2{
        left: 70px;
      }

      .row_data {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;

        &:last-of-type {
          margin-bottom: 0;
        }

        span {
          display: block;
          width: 50%;
          font-size: 12px;

          &.left {
            color: #999999;
          }

          &.top{
            margin-top: 24px;
          }

          &.right {
            text-align: right;
          }

          &.bottom{
            width: 100%;
          }

          // &.info{
          //   width: 100%;
          //   color: #ff2d55;
          // }
        }
        .info{
          width: 100%;
          color: #ff2d55;
          font-size: 13px;
        }
    }

    .price_note {
      margin-bottom: 10%;
      span {
        font-style: italic;
        font-size: 12px;
      }
    }

      .separator {
        border-bottom: 1px solid #999999;
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }

    .hide {
      display: none;
    }
  }
}

</style>
